function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });
  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);

    //const firstDetailsElement = this.querySelector("details");
    //if (firstDetailsElement) {
    //firstDetailsElement.setAttribute("id", "Details-menu-drawer-menu-item-1");
    //firstDetailsElement.setAttribute("open", "");
    //firstDetailsElement.classList.add("menu-opening");
    //}
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.giftButton = document.querySelector("#btnIframe");
    this.axeptio = document.querySelector("#axeptio_overlay");
    this.loyalty = document.querySelector("#ba-loy-container");
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    const giftButton = document.querySelector("#btnIframe");
    const axeptio = document.querySelector("#axeptio_overlay");
    const loyalty = document.querySelector("#ba-loy-container");
    const stickyATC = document.querySelector(".sticky-add-to-cart");
    const intercom = document.querySelector(".intercom-launcher");

    if (giftButton) giftButton.style.display = "none";
    if (axeptio) axeptio.style.display = "none";
    if (loyalty) loyalty.style.display = "none";
    if (stickyATC) stickyATC.style.display = "none !important";
    if (intercom) intercom.style.display = "none !important";
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    const giftButton = document.querySelector("#btnIframe");
    const axeptio = document.querySelector("#axeptio_overlay");
    const loyalty = document.querySelector("#ba-loy-container");
    const stickyATC = document.querySelector(".sticky-add-to-cart");
    const intercom = document.querySelector(".intercom-launcher");

    if (giftButton) giftButton.style.display = "block";
    if (axeptio) axeptio.style.display = "block";
    if (loyalty) loyalty.style.display = "block";
    if (stickyATC) stickyATC.style.display = "block";
    if (intercom) intercom.style.display = "block";
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderControlWrapper = this.querySelector(
      ".slideshow__control-wrapper"
    );
    if (!this.slider || !this.nextButton || !this.sliderControlWrapper) return;

    this.initPages();
    this.createDots();

    const resizeObserver = new ResizeObserver(() => {
      this.initPages();
      this.createDots();
    });

    resizeObserver.observe(this.slider);
    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (el) => el.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;

    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItemOffset
    );
    const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
    const maxScrollSteps = Math.round(maxScrollLeft / this.sliderItemOffset);

    this.totalPages = Math.min(
      this.sliderItemsToShow.length - this.slidesPerPage + 1,
      maxScrollSteps + 1
    );

    console.log("Slider Width:", this.slider.clientWidth);
    console.log("Slide Offset:", this.sliderItemOffset);
    console.log("Slides Per Page:", this.slidesPerPage);
    console.log("Total Items:", this.sliderItemsToShow.length);
    console.log("Total Pages (Fixed):", this.totalPages);
    this.createDots();
    this.update();
  }

  createDots() {
    if (!this.sliderControlWrapper) return;
    this.sliderControlWrapper.innerHTML = "";

    if (this.totalPages <= 1) {
      this.sliderControlWrapper.style.display = "none";
      return;
    } else {
      this.sliderControlWrapper.style.display = "";
    }

    // Create dots
    for (let i = 0; i < this.totalPages; i++) {
      const dot = document.createElement("button");
      dot.classList.add(
        "slider-counter__link",
        "link",
        "slider-counter__link--dots"
      );
      dot.dataset.index = i;
      dot.setAttribute("aria-label", `Slide ${i + 1}`);
      dot.innerHTML = '<span class="dot"></span>';
      dot.addEventListener("click", () => this.goToSlide(i));

      this.sliderControlWrapper.appendChild(dot);
    }

    this.updateDots();
  }

  update() {
    // Calculate current page based on scroll position
    const scrollPosition = this.slider.scrollLeft;
    const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;

    // If we're at the very end (last slide), set current page to total pages
    if (scrollPosition >= maxScrollLeft) {
      this.currentPage = this.totalPages;
    } else {
      this.currentPage = Math.round(scrollPosition / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    this.updateDots();
    this.updateButtons();

    // Debug logging (you can remove this in production)
    if (window.location.search.includes("debug=slider")) {
      console.log("Slider State:", {
        scrollPosition,
        maxScrollLeft,
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        slideItemOffset: this.sliderItemOffset,
      });
    }
  }

  updateDots() {
    if (!this.sliderControlWrapper) return;

    const dots = this.sliderControlWrapper.querySelectorAll(
      ".slider-counter__link"
    );
    dots.forEach((dot, index) => {
      dot.classList.toggle(
        "slider-counter__link--active",
        index === this.currentPage - 1
      );
    });
  }

  updateButtons() {
    if (this.prevButton) {
      this.prevButton.disabled = this.currentPage <= 1;
    }
    if (this.nextButton) {
      this.nextButton.disabled = this.currentPage >= this.totalPages;
    }
  }

  goToSlide(index) {
    // Use the same logic as onButtonClick to ensure consistent behavior
    const targetPage = index + 1; // Convert 0-based index to 1-based page number

    // Use the same logic as onButtonClick to ensure consistent behavior
    if (targetPage === this.totalPages) {
      // For the last slide, scroll to show the complete last card
      const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
      this.slideScrollPosition = maxScrollLeft;
    } else {
      this.slideScrollPosition = (targetPage - 1) * this.sliderItemOffset;
    }

    // Debug logging (you can remove this in production)
    if (window.location.search.includes("debug=slider")) {
      console.log("goToSlide:", {
        index,
        targetPage,
        totalPages: this.totalPages,
        slideScrollPosition: this.slideScrollPosition,
        maxScrollLeft: this.slider.scrollWidth - this.slider.clientWidth,
      });
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition,
      behavior: "smooth",
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;

    // Calculate the target page
    const currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    let targetPage;

    if (event.currentTarget.name === "next") {
      targetPage = currentPage + step;
    } else {
      targetPage = currentPage - step;
    }

    // Ensure target page is within bounds
    targetPage = Math.max(1, Math.min(targetPage, this.totalPages));

    // Use the same logic as goToSlide to ensure consistent behavior
    if (targetPage === this.totalPages) {
      // For the last slide, scroll to show the complete last card
      const maxScrollLeft = this.slider.scrollWidth - this.slider.clientWidth;
      this.slideScrollPosition = maxScrollLeft;
    } else {
      this.slideScrollPosition = (targetPage - 1) * this.sliderItemOffset;
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition,
      behavior: "smooth",
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector(".slider-buttons");

    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");

    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );

    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );

    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));

    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();

    if (this.slider.classList.contains("slider-progress-bar")) {
      this.scrollToActiveSlide();

      // Ajout des classes sur le contrôle des slides

      this.addControlClasses();
    }
  }

  // Méthode pour ajouter les classes au chargement de la page

  addControlClasses() {
    let activeFound = false; // Indique si on a trouvé la slide active

    this.sliderControlLinksArray.forEach((link, index) => {
      const correspondingSlide = this.sliderItemsToShow[index];

      // Ajouter la classe .slider-counter__link-step pour la slide active

      if (correspondingSlide.classList.contains("slide--active")) {
        link.classList.add("slider-counter__link-step");

        activeFound = true; // Marque que la slide active a été trouvée
      } else {
        link.classList.remove("slider-counter__link-step");
      }

      // Ajouter la classe .slider-counter__link--past pour les slides précédentes

      if (!activeFound) {
        link.classList.add("slider-counter__link--past");
      } else {
        link.classList.remove("slider-counter__link--past");
      }
    });
  }

  scrollToActiveSlide() {
    const activeSlide = this.slider.querySelector(".slide--active");

    if (activeSlide) {
      const activeSlideIndex = Array.from(this.sliderItems).indexOf(
        activeSlide
      );

      const slideScrollPosition = activeSlideIndex * activeSlide.clientWidth;

      this.slider.scrollTo({
        left: slideScrollPosition,
      });

      this.currentPage = activeSlideIndex + 1;

      this.update(); // Met à jour les boutons et l'état du slider
    }
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");

    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );

    this.addEventListener("mouseover", this.focusInHandling.bind(this));

    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));

    this.addEventListener("focusin", this.focusInHandling.bind(this));

    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();

    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);

    const isFirstSlide = this.currentPage === 1;

    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();

    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");

    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");

      link.removeAttribute("aria-current");
    });

    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );

    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);

    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();

    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);

    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;

    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);

    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");

    clearInterval(this.autoplay);

    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");

    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");

      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");

      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;

    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");

      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");

        item.setAttribute("aria-hidden", "false");

        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");

        item.setAttribute("aria-hidden", "true");

        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();

    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);

    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateBundlePrices();
      this.updateAllKlarnaWidgets();
    }
  }

  async updateAllKlarnaWidgets() {
    const klarnaPlacements = document.querySelectorAll("klarna-placement");
    if (!klarnaPlacements.length || !this.currentVariant) return;

    const variantPriceWithDiscount = await this.calculateDiscountedPrice(
      this.currentVariant.price
    );

    klarnaPlacements.forEach((klarnaPlacement) => {
      klarnaPlacement.setAttribute(
        "data-purchase-amount",
        variantPriceWithDiscount.toString()
      );
    });

    // Refresh Klarna widgets
    if (window.Klarna?.OnsiteMessaging) {
      Klarna.OnsiteMessaging.refresh();
    }
  }

  async calculateDiscountedPrice(basePrice) {
    const collections = await this.getProductCollections();
    const highestDiscount = this.getHighestDiscount(collections);
    const discountMultiplier = 1 - highestDiscount / 100;

    return Math.floor(basePrice * discountMultiplier);
  }

  getHighestDiscount(collections) {
    if (!collections || !collections.length) return 0;

    return collections.reduce((max, collection) => {
      const discount = parseFloat(collection.metafields?.custom?.discount || 0);
      return Math.max(max, discount);
    }, 0);
  }

  async getProductCollections() {
    return window.productCollections || (await this.fetchProductCollections());
  }

  async fetchProductCollections() {
    try {
      const response = await fetch("/collections-endpoint"); // Replace with actual endpoint
      if (response.ok) {
        return await response.json();
      }
      console.error("Failed to fetch product collections");
    } catch (error) {
      console.error("Error fetching collections:", error);
    }
    return [];
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateBundlePrices() {
    const allBundles = document.querySelectorAll(".pack");
    if (!allBundles) return;
    allBundles.forEach((bundle) => {
      const quantity = parseInt(bundle.dataset.quantity, 10);
      const fakeQuantity = parseInt(bundle.dataset.fakeQuantity, 10);
      const price = bundle.querySelector(".pack-price-normal");
      const compareAtPrice = bundle.querySelector(".pack-compared-price");
      if (quantity == 0 || fakeQuantity == 0) return;
      if (price) {
        price.innerHTML = new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "EUR",
        }).format((this.currentVariant.price * quantity) / 100);
      }
      if (compareAtPrice) {
        compareAtPrice.innerHTML = new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "EUR",
        }).format((this.currentVariant.price * fakeQuantity) / 100);
      }
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    //stock counter alert
    const varIndex = variantsObj.findIndex(
      (o) => parseInt(o.id) === this.currentVariant.id
    );
    const varQuantity = variantsObj[varIndex].inventory_qty;

    if (document.getElementById("unseenclass")) {
      var nbindic = document.getElementById("unseenclass"),
        indicNum = parseInt(nbindic.textContent);
      // textContent = "Some sample text."
      if (varQuantity > indicNum) {
        document.querySelector(".stock-disp").innerHTML = "Disponible";
        document.querySelector(".stock-indic").style.background = "green";
        document.querySelector(".klaviyo-bis-trigger").style.display = "none";
      } else if (varQuantity <= indicNum && varQuantity > 0) {
        document.querySelector(
          ".stock-disp"
        ).innerHTML = `Plus que ${varQuantity} en stock`;
        document.querySelector(".stock-indic").style.background = "orange";
        document.querySelector(".klaviyo-bis-trigger").style.display = "none";
      } else if (varQuantity <= 0) {
        document.querySelector(".stock-disp").innerHTML = `Indisponible`;
        document.querySelector(".stock-indic").style.background = "red";
        document.querySelector(".product-form").style.display = "none";
        document.querySelector(".klaviyo-bis-trigger").style.display = "block";
      }
    }
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const destinationPriceButtonSticky =
          document.querySelector(".priceButtonSticky");
        const sourcePriceButtonSticky = html.querySelector(
          ".price-item-sticky_atc"
        );

        const sourceVariantsSticky = html.querySelector(".sticky-atc__select");
        const destinationVariantsSticky = document.querySelector(
          ".sticky-atc__select"
        );

        const sourceVariants = html.querySelector(".variant-group-custom");
        const destinationVariants = document.querySelector(
          ".variant-group-custom"
        );

        const destinationATC = document.querySelector("#productMainSubmit");
        const sourceATC = html.querySelector("#productMainSubmit");

        if (destinationPriceButtonSticky && sourcePriceButtonSticky)
          destinationPriceButtonSticky.innerHTML =
            sourcePriceButtonSticky.innerHTML;
        if (destinationVariantsSticky && sourceVariantsSticky)
          destinationVariantsSticky.innerHTML = sourceVariantsSticky.innerHTML;
        if (destinationVariants && sourceVariants)
          destinationVariants.innerHTML = sourceVariants.innerHTML;
        if (destinationATC && sourceATC)
          destinationATC.innerHTML = sourceATC.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove("visibility-hidden");

        updateStickyAtc(
          this.currentVariant.id,
          this.dataset.url,
          document.querySelector(".price-item-sticky_atc"),
          this.dataset.section
        );

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      //addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

const searchInModalInput = document.querySelector("#Search-In-Modal");
// all the search-modal__best-searchs-list-item
const searchModalBestSearchs = document.querySelectorAll(
  ".search-modal__best-searchs-list-item"
);

function simulateBackspaceKeyPress(element) {
  const currentValue = element.value;
  element.focus();
  element.value = currentValue.slice(0, -1);
  const event = new Event("input", { bubbles: true });
  element.dispatchEvent(event);
}

// when the user clicks on one of the best searchs write like an user type it in the input and reset every click
searchModalBestSearchs.forEach((searchModalBestSearch) => {
  searchModalBestSearch.addEventListener("click", () => {
    // Simulate a "backspace" keypress to clear the input field
    searchInModalInput.value = "";
    searchInModalInput.focus();
    simulateBackspaceKeyPress(searchInModalInput, true);

    if (window.themeShop == "HHC") {
      searchInModalInput.value =
        searchModalBestSearch.textContent === "HHC" ||
        searchModalBestSearch.textContent === "H4CBD"
          ? (searchInModalInput.value = "H")
          : searchModalBestSearch.textContent;
    } else if (window.themeShop == "STOMRORCK") {
      searchInModalInput.value = searchModalBestSearch.textContent;
    } else {
      searchInModalInput.value = searchModalBestSearch.textContent;
    }
    searchInModalInput.focus();
  });
});

/* let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  item.addEventListener("mouseleave", () => {
    item.removeAttribute("open");
  });
});

}); */

//Sticky ATC

function handleStickyATC() {
  const scroll = window.scrollY;
  const stickyTriggerElement = document.querySelector("#productMainSubmit");
  const stickyATC = document.querySelector(".sticky-add-to-cart");
  const chatbox = document.querySelector(".intercom-launcher");

  if (stickyTriggerElement) {
    const stickyTrigger =
      stickyTriggerElement.getBoundingClientRect().top + window.scrollY;
    const stickyTriggerHeight = stickyTriggerElement.offsetHeight;
    const windowHeight = window.innerHeight;

    // Check if stickyTriggerElement is in the viewport
    if (
      scroll + windowHeight > stickyTrigger &&
      scroll < stickyTrigger + stickyTriggerHeight
    ) {
      // Element is visible, hide stickyATC
      stickyATC.style.visibility = "hidden";
      stickyATC.style.opacity = "0";
      if (chatbox) chatbox.style.bottom = ""; // Reset to default
      if (chatbox) chatbox.style.top = "block"; // Reset to default
    } else {
      // Element is not visible, show stickyATC
      stickyATC.style.visibility = "visible";
      stickyATC.style.opacity = "1";
    }
  }
}
window.addEventListener("scroll", handleStickyATC);
window.addEventListener("DOMContentLoaded", handleStickyATC);

async function updateStickyAtc(id, url, priceElement, section) {
  const res = await fetch(`${url}?variant=${id}&section_id=${section}`);
  const text = await res.text();

  const html = new DOMParser().parseFromString(text, "text/html");

  const source = html.querySelector(".price-item-sticky_atc");
  const sourcePriceATC = html.querySelector(".prices-items-collection");

  const sourcePrice = html.getElementById(`price-${section}`);
  const sourceVariants = html.querySelector(".variant-group-custom");

  // Get the sticky ATC button from the fetched HTML
  const sourceStickyButton = html.querySelector(
    ".sticky-add-to-cart .product-form__submit"
  );

  const destinationPrice = document.getElementById(`price-${section}`);
  const destinationVariants = document.querySelector(".variant-group-custom");
  const destinationPriceATC = document.querySelector(
    ".prices-items-collection"
  );

  // Get the current sticky ATC button
  const destinationStickyButton = document.querySelector(
    ".sticky-add-to-cart .product-form__submit"
  );

  if (source && priceElement) priceElement.innerHTML = source.innerHTML;
  if (sourcePrice && destinationPrice)
    destinationPrice.innerHTML = sourcePrice.innerHTML;
  if (sourceVariants && destinationVariants)
    destinationVariants.innerHTML = sourceVariants.innerHTML;
  if (sourcePriceATC && destinationPriceATC)
    destinationPriceATC.innerHTML = sourcePriceATC.innerHTML;

  // Update the sticky ATC button state and content
  if (sourceStickyButton && destinationStickyButton) {
    // Update button text content without breaking the form structure
    const sourceButtonText = sourceStickyButton.querySelector("div");
    const destinationButtonText = destinationStickyButton.querySelector("div");
    if (sourceButtonText && destinationButtonText) {
      destinationButtonText.innerHTML = sourceButtonText.innerHTML;
    }

    // Handle price content update - this is more complex because the price span might not exist
    const sourcePriceSpan = sourceStickyButton.querySelector(
      ".prices-items-collection"
    );
    const destinationPriceSpan = destinationStickyButton.querySelector(
      ".prices-items-collection"
    );

    if (sourcePriceSpan) {
      // Source has price span (variant is available)
      if (destinationPriceSpan) {
        // Destination also has price span, just update content
        destinationPriceSpan.innerHTML = sourcePriceSpan.innerHTML;
      } else {
        // Destination doesn't have price span, need to add separator and price span after the text div
        const textDiv = destinationStickyButton.querySelector("div");
        if (textDiv) {
          // Add the separator first
          const separatorSpan = document.createElement("span");
          separatorSpan.innerHTML = "&nbsp;|&nbsp;";
          textDiv.insertAdjacentElement("afterend", separatorSpan);

          // Then add the price span
          const newPriceSpan = sourcePriceSpan.cloneNode(true);
          separatorSpan.insertAdjacentElement("afterend", newPriceSpan);
        }
      }
    } else {
      // Source doesn't have price span (variant is unavailable), remove separator and price span from destination
      if (destinationPriceSpan) {
        destinationPriceSpan.remove();
      }
      // Also remove the separator span if it exists
      const separatorSpan = destinationStickyButton.querySelector("span");
      if (separatorSpan && separatorSpan.innerHTML === "&nbsp;|&nbsp;") {
        separatorSpan.remove();
      }
    }

    // Update disabled state
    if (sourceStickyButton.hasAttribute("disabled")) {
      destinationStickyButton.setAttribute("disabled", "disabled");
    } else {
      destinationStickyButton.removeAttribute("disabled");
    }

    // Update hidden input value in sticky ATC
    const sourceHiddenInput = html.querySelector(
      '.sticky-add-to-cart input[name="id"]'
    );
    const destinationHiddenInput = document.querySelector(
      '.sticky-add-to-cart input[name="id"]'
    );
    if (sourceHiddenInput && destinationHiddenInput) {
      destinationHiddenInput.value = sourceHiddenInput.value;
    }
  }
}

async function updateCollectionAtc(id, url, card) {
  try {
    const response = await fetch(`${url}?variant=${id}`);
    const responseText = await response.text();
    const responseHtml = new DOMParser().parseFromString(
      responseText,
      "text/html"
    );

    // Get the parent <li> that contains both cards
    const parentListItem = card.closest("li");
    if (!parentListItem) return;

    // Find all cards inside the parent
    const cardElements = parentListItem.querySelectorAll(".card");

    // Update all cards in the parent container
    cardElements.forEach((cardElement) => {
      // Update variant IDs in forms
      const form = cardElement.querySelector("form");
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = id;
        }
      }

      // Skip hidden cards for visual updates
      if (window.getComputedStyle(cardElement).display === "none") return;

      // Update entire price containers (parent approach)
      const priceContainerDestination = cardElement.querySelector(
        ".prices-items-collection"
      );
      const priceContainerSource = responseHtml.querySelector(
        ".prices-items-collection"
      );

      if (priceContainerSource && priceContainerDestination) {
        priceContainerDestination.innerHTML = priceContainerSource.innerHTML;
      }

      // Also update the compare-at price element specifically to ensure proper display
      const compareAtPriceDestination = cardElement.querySelector(
        ".price-item-collection_atc"
      );
      const compareAtPriceSource = responseHtml.querySelector(
        ".price-item-collection_atc"
      );

      if (compareAtPriceSource && compareAtPriceDestination) {
        compareAtPriceDestination.innerHTML = compareAtPriceSource.innerHTML;
        compareAtPriceDestination.style.display = "inline";
      } else if (compareAtPriceDestination) {
        // Hide compare-at price if new variant doesn't have one
        compareAtPriceDestination.style.display = "none";
      }

      // Update price container in button if it exists separately
      const buttonPriceDestination = cardElement.querySelector(
        ".product-card__button-prices"
      );
      const buttonPriceSource = responseHtml.querySelector(
        ".product-card__button-prices"
      );

      if (buttonPriceSource && buttonPriceDestination) {
        buttonPriceDestination.innerHTML = buttonPriceSource.innerHTML;
      }

      // Update price badge container (per gram pricing)
      const priceBadgeDestination = cardElement.querySelector(
        ".card-product-badge-gr"
      );
      const priceBadgeSource = responseHtml.querySelector(
        ".card-product-badge-gr"
      );

      if (priceBadgeSource && priceBadgeDestination) {
        priceBadgeDestination.innerHTML = priceBadgeSource.innerHTML;
      }

      // Update variant name
      const variantNameDestination =
        cardElement.querySelector(".variant-item_name");
      const variantNameSource = responseHtml.querySelector(
        ".variant-group-new .variant-group-custom__label--active .variant-group-custom__value"
      );
      if (variantNameSource && variantNameDestination) {
        variantNameDestination.innerHTML = variantNameSource.innerHTML;
      }

      // Update discount badge if it exists
      const discountBadgeDestination =
        cardElement.querySelector(".card-top-badge-2");
      const discountBadgeSource =
        responseHtml.querySelector(".card-top-badge-2");

      if (discountBadgeSource && discountBadgeDestination) {
        discountBadgeDestination.innerHTML = discountBadgeSource.innerHTML;
        discountBadgeDestination.style.display =
          discountBadgeSource.style.display || "block";
      } else if (discountBadgeDestination) {
        // Hide discount badge if no discount in new variant
        discountBadgeDestination.style.display = "none";
      }
    });
  } catch (error) {
    console.error("Error updating collection ATC:", error);
  }
}

//Sticky atc select change
const selectsStickyAtc = document.querySelectorAll(".sticky-atc__select");
selectsStickyAtc.forEach((select) => {
  select.addEventListener("change", () => {
    const idVariant = select.value;
    const urlVariant = select.dataset.url;
    const sectionId = select.dataset.section;
    const priceElement = document.querySelector(".price-item-sticky_atc");

    updateStickyAtc(idVariant, urlVariant, priceElement, sectionId);
  });
});

//Collection page ATC
const selectsCollectionAtc = document.querySelectorAll(
  ".collection-atc__select"
);
selectsCollectionAtc.forEach((select) => {
  select.addEventListener("change", () => {
    const idVariant = select.value;
    const urlVariant = select.dataset.url;
    const cardId = select.dataset.card;
    const productCardVariant = document.getElementById(cardId);

    // Update the variant ID in the form
    if (productCardVariant) {
      const form = productCardVariant.querySelector("form");
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = idVariant;
        }
      }
    }

    updateCollectionAtc(idVariant, urlVariant, productCardVariant);
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".card-wrapper").forEach((cardWrapper, i) => {
    const radios = cardWrapper.querySelectorAll("input[type='radio']");
    radios.forEach((radio, j) => {
      console.log(
        `[CARD ${i}] Radio ${j} — name: ${radio.name}, id: ${radio.id}, checked: ${radio.checked}`
      );
    });
  });
  document.querySelectorAll(".card-wrapper").forEach((cardWrapper) => {
    const checkedRadio = cardWrapper.querySelector(
      "input[type='radio']:checked"
    );
    if (checkedRadio) {
      const label = cardWrapper.querySelector(
        `label[for='${checkedRadio.id}']`
      );
      if (label) {
        label.classList.add("variant-group-custom__label--active");
      }
    }
  });
});

if (window.innerWidth > 750) {
  const cardCollection = document.querySelectorAll(".card");
  cardCollection.forEach((card) => {
    card.addEventListener("mouseover", () => {
      const atcButton = card.querySelector(".quick_atc");
      card.classList.add("atc-active");
    });

    card.addEventListener("mouseout", () => {
      const atcButton = card.querySelector(".quick_atc");
      card.classList.remove("atc-active");
    });
  });
}

const titleTab = document.querySelector("title").innerHTML;
const ongletText1 = document.querySelector(".favicon__link").dataset.onglet1;
const ongletText2 = document.querySelector(".favicon__link").dataset.onglet2;
const ongletText3 = document.querySelector(".favicon__link").dataset.onglet3;
const ongletArray = [
  ongletText1,
  titleTab,
  ongletText2,
  titleTab,
  ongletText3,
  titleTab,
];
var myIntervalRef;

function textInterval() {
  var index = 0;
  const textInterval = setInterval(function () {
    document.querySelector("title").innerHTML =
      ongletArray[index++ % ongletArray.length];
  }, 2000);
  return textInterval;
}

if (ongletText1 != undefined) {
  document.addEventListener("visibilitychange", (event) => {
    if (document.visibilityState == "visible") {
      clearInterval(myIntervalRef);
      document.querySelector("title").innerHTML = titleTab;
    } else {
      myIntervalRef = textInterval();
    }
  });
}

class ProductCrossells extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".product-crossell-btn");
    this.buttonPrice = this.button.querySelector(
      ".product-crossell-btn--price"
    );
    this.checkboxes = this.querySelectorAll(".crossell-fake-checkbox");
    this.products = this.querySelectorAll("product-crossell");
    this.idsToAdd = [];
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
  }

  connectedCallback() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.updateIdsToAdd.bind(this));
    });
    this.button.addEventListener("click", this.addToCart.bind(this));
  }

  updateIdsToAdd() {
    this.idsToAdd = [];
    let price = 0;
    this.checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        price += parseInt(checkbox.dataset.price, 10);
        this.idsToAdd.push(checkbox.dataset.id);
      }
    });

    this.updateButton(price, this.idsToAdd);
  }

  updateButton(price, ids) {
    if (price === 0 || ids.length === 0) {
      this.button.setAttribute("disabled", "disabled");
      this.button.innerHTML = `${window.variantStrings.selectAtLeastOneProduct} <span class="product-crossell-btn--price"></span>`;
      this.button.querySelector(".product-crossell-btn--price").innerHTML = "";
      return;
    }
    this.button.removeAttribute("disabled");
    this.button.innerHTML = `${window.variantStrings.addToCart} <span class="product-crossell-btn--price"></span>`;
    this.button.querySelector(
      ".product-crossell-btn--price"
    ).innerHTML = ` | ${new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR",
    }).format(price / 100)}`;
  }

  addToCart() {
    let formData = {};
    let items = [];
    this.idsToAdd.forEach((id) => {
      items.push({
        id: id,
        quantity: 1,
      });
    });
    formData.items = items;
    if (this.cart) {
      formData.sections = this.cart
        .getSectionsToRender()
        .map((section) => section.id);
      formData.sections_url = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        this.cart.renderContents(data);
        //window.location = window.routes.cart_url;
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        if (this.cart && this.cart.classList.contains("is-empty"))
          this.cart.classList.remove("is-empty");
      });
  }
}

customElements.define("product-crossells", ProductCrossells);

class ProductCrossell extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector(".crossell-fake-checkbox");
    this.select = this.querySelector("select");
    this.image = this.querySelector(".media img");
  }
  connectedCallback() {
    if (this.select) {
      this.select.addEventListener("change", this.updateId.bind(this));
    }
  }

  updateId(e) {
    this.checkbox.dataset.id = e.target.value;
    if (!e.target.selectedOptions[0].dataset.image) {
      return;
    }
    this.image.src = e.target.selectedOptions[0].dataset.image;
    this.image.removeAttribute("srcset");
  }
}

customElements.define("product-crossell", ProductCrossell);

console.log(localStorage);
console.log(localStorage);

class CustomProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.productcheckboxes = [];
    this.productselects = [];
  }

  connectedCallback() {
    this.attachCheckboxEvents();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector(
            "custom-product-recommendations"
          );

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }

          // Réattache les événements après la mise à jour du contenu
          this.attachCheckboxEvents();
          this.attachSelectEvents();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }

  attachCheckboxEvents() {
    this.productcheckboxes = this.querySelectorAll(
      'input[name="related-product-checkbox"]'
    );
    this.productcheckboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.onCheckboxChange.bind(this));
      if (checkbox.checked && checkbox.dataset.available == "false") {
        checkbox.click();
        checkbox.checked = false;
      }
    });
  }

  attachSelectEvents() {
    this.productselects = this.querySelectorAll(".related-product-select");
    this.productselects.forEach((select) => {
      select.addEventListener("change", this.onSelectChange.bind(this));
    });
  }

  onCheckboxChange(event) {
    this.updateInputs(event);
    this.updateSectionContent(event);
  }

  onSelectChange(event) {
    const inputsContainer = this.querySelector(
      ".custom-related-products--inputs"
    );
    const input = inputsContainer.querySelector(
      `[data-product-id="${event.target.dataset.productId}"]`
    );
    const checkboxInput = this.querySelector(
      `input[name="related-product-checkbox"][data-product-id="${event.target.dataset.productId}"]`
    );
    this.updateVariantPrice(event);
    this.updateMedia(event);
    if (!input) return;
    input.value = event.target.options[event.target.selectedIndex].value;
    if (!checkboxInput) return;
    checkboxInput.dataset.id =
      event.target.options[event.target.selectedIndex].value;
    this.updateSectionContent(event);
  }

  updateMedia(event) {
    fetch(
      window.Shopify.routes.root + `products/${event.target.dataset.handle}.js`
    )
      .then((response) => response.json())
      .then((product) => {
        const variant = product.variants.find(
          (variant) =>
            variant.id == event.target.options[event.target.selectedIndex].value
        );
        const newImageUrl = variant.featured_image; // Assure-toi que cette URL est correcte

        const oldMedia = event.target
          .closest(".card")
          .querySelector(".card__media img");
        if (oldMedia && newImageUrl) {
          oldMedia.src = newImageUrl.src;

          const newSrcset = oldMedia.srcset
            .split(",")
            .map((src) => {
              const parts = src.split(" ");
              parts[0] = newImageUrl.src;
              return parts.join(" ");
            })
            .join(",");

          oldMedia.srcset = newSrcset;

          oldMedia.alt = variant.title;
        }
      });
  }

  async updateVariantPrice(event) {
    const handle = event.target.dataset.handle;
    const variantId = event.target.options[event.target.selectedIndex].value;

    try {
      // Get the product data with the selected variant
      const productResponse = await fetch(
        `${window.Shopify.routes.root}products/${handle}.js`
      );
      const productData = await productResponse.json();
      const selectedVariant = productData.variants.find(
        (v) => v.id == variantId
      );

      if (!selectedVariant) {
        throw new Error("Variant not found");
      }

      const cardElement = event.target.closest(".card-wrapper");
      const multiplier =
        parseFloat(event.target.dataset.discountMultiplier) || 1;

      // Update the entire price structure based on variant data
      this.updateCardPriceStructure(
        cardElement,
        selectedVariant,
        productData,
        multiplier
      );
    } catch (error) {
      console.error("Error updating variant price:", error);
      // Fallback to old method if section fetch fails
      this.updateVariantPriceFallback(event);
    }
  }

  updateCardPriceStructure(cardElement, variant, product, multiplier) {
    // Update price container (for cards using price snippet)
    const priceContainer = cardElement.querySelector(".price");
    if (priceContainer) {
      // Update price classes based on variant
      const hasComparePrice =
        variant.compare_at_price && variant.compare_at_price > variant.price;
      const hasDiscount = multiplier < 1;

      priceContainer.classList.toggle("price--on-sale", hasComparePrice);
      priceContainer.classList.toggle("price--sold-out", !variant.available);

      // Update price container content
      const priceContainerDiv =
        priceContainer.querySelector(".price__container");
      if (priceContainerDiv) {
        priceContainerDiv.classList.toggle("show_price", hasDiscount);
      }

      // Update regular price content
      const regularPriceContent = priceContainer.querySelector(
        ".product-card__button-price__content"
      );
      if (regularPriceContent) {
        regularPriceContent.textContent = this.formatPrice(variant.price);
      }

      // Update discounted price
      const newPrice = priceContainer.querySelector(
        ".product-card__button-price--new"
      );
      if (newPrice) {
        newPrice.textContent = this.formatPrice(variant.price * multiplier);
      }
    }

    // Update button price structure (for cards with button prices)
    const buttonPricesContainer = cardElement.querySelector(
      ".prices-items-collection"
    );
    if (buttonPricesContainer) {
      // Update compare at price display
      const compareAtPriceElement = buttonPricesContainer.querySelector(
        ".price-item-collection_atc"
      );
      if (compareAtPriceElement) {
        if (variant.compare_at_price && variant.compare_at_price > 0) {
          compareAtPriceElement.textContent = this.formatPrice(
            variant.compare_at_price
          );
          compareAtPriceElement.closest(".price-item--regular").style.display =
            "block";
        } else {
          compareAtPriceElement.textContent = this.formatPrice(variant.price);
          // Show/hide based on discount logic
          const shouldShow = !(variant.compare_at_price === 0);
          compareAtPriceElement.closest(".price-item--regular").style.display =
            shouldShow ? "block" : "none";
        }
      }

      // Update final price
      const finalPriceElement = buttonPricesContainer.querySelector(
        ".product-card__button-price--new"
      );
      if (finalPriceElement) {
        finalPriceElement.textContent = this.formatPrice(
          variant.price * multiplier
        );
      }
    }

    // Update per gram badge if it exists
    const gramBadge = cardElement.querySelector(".card-product-badge-gr");
    if (gramBadge && variant.title) {
      const variantTitle = variant.title.split(" ");
      const gramsText = variantTitle[0];
      const grams = parseFloat(gramsText.replace(/[^0-9.]/g, ""));

      if (grams > 0) {
        const pricePerGram = (variant.price * multiplier) / grams;
        gramBadge.textContent =
          this.formatPriceWithoutCurrency(pricePerGram) + "€/gr";
      }
    }

    // Update discount badge
    const discountBadge = cardElement.querySelector(".card-top-badge-2");
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const discountPercentage = Math.ceil(
        ((variant.compare_at_price - variant.price) /
          variant.compare_at_price) *
          100
      );
      if (discountBadge) {
        discountBadge.textContent = `-${discountPercentage}%`;
        discountBadge.style.display = "block";
      }
    } else if (discountBadge) {
      discountBadge.style.display = "none";
    }
  }

  formatPrice(priceInCents) {
    return (
      new Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(priceInCents / 100) + " €"
    );
  }

  formatPriceWithoutCurrency(priceInCents) {
    return new Intl.NumberFormat("fr-FR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(priceInCents / 100);
  }

  updateVariantPriceFallback(event) {
    fetch(
      window.Shopify.routes.root + `products/${event.target.dataset.handle}.js`
    )
      .then((response) => response.json())
      .then((product) => {
        const variant = product.variants.find(
          (variant) =>
            variant.id == event.target.options[event.target.selectedIndex].value
        );
        let multiplier = event.target.dataset.discountMultiplier;
        let pricesContainer = event.target
          .closest(".card__content")
          .querySelector(".price__container");
        pricesContainer = pricesContainer.querySelector(".price__regular");
        pricesContainer.querySelector(
          ".product-card__button-price__content"
        ).innerText = `${Intl.NumberFormat("fr-FR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(variant.price / 100)} €`;
        pricesContainer.querySelector(
          ".product-card__button-price--new"
        ).innerText = `${Intl.NumberFormat("fr-FR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format((variant.price * multiplier) / 100)} €`;
      });
  }

  updateSectionContent(event) {
    const buttonContainer = this.querySelectorAll(
      ".custom-related-products--buttons"
    );
    const pricesSumContainer = this.querySelectorAll(
      ".custom-related-products--price"
    );
    const comparePriceSumContainer = this.querySelectorAll(
      ".custom-related-products--compare-price"
    );
    const productsCounter = this.querySelectorAll(
      ".custom-related-products--counter"
    );

    let pricesSum = 0;
    let comparePricesSum = 0;
    productsCounter.innerText = this.querySelectorAll(
      'input[name="related-product-checkbox"]:checked'
    ).length;
    if (
      this.querySelectorAll('input[name="related-product-checkbox"]:checked')
        .length > 0
    ) {
      buttonContainer.forEach((buttonContainer) => {
        buttonContainer.classList.remove("button--hidden");
      });
      productsCounter.forEach((counter) => {
        counter.innerText = this.querySelectorAll(
          'input[name="related-product-checkbox"]:checked'
        ).length;
      });
    } else {
      buttonContainer.forEach((buttonContainer) => {
        buttonContainer.classList.add("button--hidden");
      });
      productsCounter.forEach((counter) => {
        counter.innerText = "";
      });
    }

    const fetchPromises = Array.from(
      this.querySelectorAll('input[name="related-product-checkbox"]:checked')
    ).map((checkbox) =>
      fetch(
        window.Shopify.routes.root + `products/${checkbox.dataset.handle}.js`
      ).then((response) => response.json())
    );

    Promise.all(fetchPromises).then((products) => {
      products.forEach((product) => {
        let variant;
        if (event.target.tagName == "SELECT") {
          variant = product.variants.find(
            (variant) =>
              variant.id ==
              event.target.options[event.target.selectedIndex].value
          );
        } else {
          variant = product.variants.find(
            (variant) => variant.id == event.target.dataset.id
          );
        }
        let multiplier = event.target.dataset.discountMultiplier;
        // in all  the input[name="related-product-checkbox"]:checked verify if product.id == input.dataset.productId
        this.querySelectorAll(
          'input[name="related-product-checkbox"]:checked'
        ).forEach((input) => {
          if (input.dataset.productId == product.id) {
            variant = product.variants.find(
              (variant) => variant.id == input.dataset.id
            );
            multiplier = input.dataset.discountMultiplier;
          }
        });
        if (variant == undefined) {
          console.log(product);
          pricesSum += parseFloat(product.price * multiplier);
          comparePricesSum += parseFloat(product.compare_at_price);
        } else {
          console.log(variant);
          pricesSum += parseFloat(variant.price * multiplier);
          comparePricesSum += parseFloat(variant.compare_at_price);
        }
      });
      pricesSumContainer.forEach((pricesSumContainer) => {
        pricesSumContainer.innerText = `${Intl.NumberFormat("fr-FR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(pricesSum / 100)} €`;
      });
      if (comparePriceSumContainer && comparePricesSum > pricesSum) {
        comparePriceSumContainer.forEach((comparePriceSumContainer) => {
          comparePriceSumContainer.innerText = `${Intl.NumberFormat("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(comparePricesSum / 100)} €`;
        });
      }
    });
  }

  updateInputs(event) {
    const inputsContainer = this.querySelector(
      ".custom-related-products--inputs"
    );
    const inputs = inputsContainer.querySelectorAll(
      `[data-product-id="${event.target.dataset.productId}"]`
    );
    if (!event.target.checked) {
      inputs.forEach((input) => {
        input.remove();
      });
      // Réindexer les inputs après la suppression
      const allInputs = inputsContainer.querySelectorAll("input");
      allInputs.forEach((input, index) => {
        input.name = `items[${index}][id]`;
      });
    } else {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = `items[${inputsContainer.childElementCount}][id]`;
      input.value = event.target.dataset.id;
      input.setAttribute("data-product-id", event.target.dataset.productId);
      inputsContainer.appendChild(input);
    }
  }
}

customElements.define(
  "custom-product-recommendations",
  CustomProductRecommendations
);

if (!customElements.get("date-counter")) {
  customElements.define(
    "date-counter",
    class DateCounter extends HTMLElement {
      constructor() {
        super();
        this.countdownDateAttr = this.getAttribute("data-end-date");
        this.countdownDate = new Date(this.countdownDateAttr);
        console.log(this.countdownDate);
        if (isNaN(this.countdownDate)) {
          console.error("Invalid date format:", this.countdownDateAttr);
          this.querySelector(".countdown-timer").textContent = "Date invalide";
          return;
        }
      }

      connectedCallback() {
        this.updateCountdown();
        this.interval = setInterval(() => this.updateCountdown(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      updateCountdown() {
        const now = new Date().getTime();
        const distance = this.countdownDate.getTime() - now;

        if (distance < 0) {
          this.querySelector(".countdown-timer").textContent = "Temps écoulé";
          this.classList.add("hidden");
          clearInterval(this.interval);
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        // Affichage des jours, même s'ils sont à 0
        this.querySelector(".countdown-timer__days--value").textContent = days;
        this.querySelector(".countdown-timer__hours--value").textContent =
          hours;
        this.querySelector(".countdown-timer__minutes--value").textContent =
          minutes;
        this.querySelector(".countdown-timer__seconds--value").textContent =
          seconds;
      }
    }
  );
}

function updateMegaMenuOverlay() {
  const menuItems = document.querySelectorAll(
    ".header__menu-item.list-menu__item.link.focus-inset"
  );
  const body = document.body;
  const overlay = document.getElementById("mega-menu-overlay");

  if (!overlay) return;

  // Observer pour surveiller les changements d'attributs
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "aria-expanded"
      ) {
        const isExpanded = document.querySelector(
          '.header__menu-item.list-menu__item.link.focus-inset[aria-expanded="true"]'
        );
        let isMegaMenu = false;
        if (isExpanded) {
          // Vérifie si le menu ouvert est un méga menu (ul.header__submenu.global-settings-popup)
          const details = isExpanded.closest("details");
          if (details) {
            const submenu = details.querySelector(".header__submenu");
            if (
              submenu &&
              submenu.classList.contains("global-settings-popup")
            ) {
              isMegaMenu = true;
            }
          }
        }
        if (isExpanded && isMegaMenu) {
          body.classList.add("mega-menu-overlay--active");
          overlay.addEventListener("click", closeExpandedMenu);
        } else {
          body.classList.remove("mega-menu-overlay--active");
          overlay.removeEventListener("click", closeExpandedMenu);
        }
      }
    });
  });

  // Fonction pour fermer le menu étendu
  function closeExpandedMenu() {
    const expandedMenu = document.querySelector(
      '.header__menu-item.list-menu__item.link.focus-inset[aria-expanded="true"]'
    );
    if (expandedMenu) {
      expandedMenu.setAttribute("aria-expanded", "false");
      expandedMenu.closest("details").removeAttribute("open");
      body.classList.remove("mega-menu-overlay--active");
    }
  }

  // Observer chaque élément de menu
  menuItems.forEach((item) => {
    observer.observe(item, {
      attributes: true,
      attributeFilter: ["aria-expanded"],
    });
  });

  // Fermer le menu avec la touche Escape
  document.addEventListener("keydown", (event) => {
    if (
      event.key === "Escape" &&
      body.classList.contains("mega-menu-overlay--active")
    ) {
      closeExpandedMenu();
    }
  });
}

// Initialize mega menu overlay
document.addEventListener("DOMContentLoaded", updateMegaMenuOverlay);

// Utility function to manage variant label states
function updateVariantLabelStates(cardWrapper, selectedRadioId = null) {
  if (!cardWrapper) return;

  // Remove active classes from all labels
  const allLabels = cardWrapper.querySelectorAll(
    ".variant-group-custom__label, .variant-button"
  );
  allLabels.forEach((label) => {
    label.classList.remove("variant-group-custom__label--active");
    label.classList.remove("variant-button-card-2025--active");
  });

  // Uncheck all radio buttons in this card
  const allRadios = cardWrapper.querySelectorAll("input[type='radio']");
  allRadios.forEach((radio) => {
    radio.checked = false;
  });

  // If we have a specific selected radio, check it and activate its label
  if (selectedRadioId) {
    const radio = cardWrapper.querySelector(
      `input[type='radio'][id='${selectedRadioId}']`
    );
    if (radio) {
      radio.checked = true;
      const label = cardWrapper.querySelector(
        `label[for='${selectedRadioId}']`
      );
      if (label) {
        label.classList.add("variant-group-custom__label--active");
        label.classList.add("variant-button-card-2025--active");
      }
    }
  } else {
    // For initialization, add active classes to checked radio labels
    const checkedRadios = cardWrapper.querySelectorAll(
      "input[type='radio']:checked"
    );
    checkedRadios.forEach((radio) => {
      const label = cardWrapper.querySelector(`label[for='${radio.id}']`);
      if (label) {
        label.classList.add("variant-group-custom__label--active");
        label.classList.add("variant-button-card-2025--active");
      }
    });
  }
}

// Initialize variant states on page load
function initializeVariantStates() {
  document.querySelectorAll(".card-wrapper").forEach((cardWrapper) => {
    // Find the first radio button in each card
    const firstRadio = cardWrapper.querySelector("input[type='radio']");
    if (firstRadio) {
      // Check the first radio and update its label state
      firstRadio.checked = true;
      updateVariantLabelStates(cardWrapper, firstRadio.id);
    }
  });
}

// Set up event listeners when DOM is loaded
document.addEventListener("DOMContentLoaded", initializeVariantStates);

// Expose functions globally if needed
window.updateVariantLabelStates = updateVariantLabelStates;
window.initializeVariantStates = initializeVariantStates;

class CollectionVariantRadios extends VariantSelects {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    const radio = event.target;
    if (radio.type === "radio") {
      const cardWrapper = radio.closest(".card-wrapper");
      if (!cardWrapper) return;

      // Update hidden input
      const hiddenInput = cardWrapper.querySelector('input[name="id"]');
      if (hiddenInput) hiddenInput.value = radio.value;

      // Update label states
      updateVariantLabelStates(cardWrapper, radio.id);

      // Handle AJAX update if needed∂
      const urlVariant = this.dataset.url;
      if (window.updateCollectionAtc) {
        window.updateCollectionAtc(
          radio.value,
          urlVariant,
          cardWrapper.querySelector(".card")
        );
      }
    }
  }
}

customElements.define("collection-variant-radios", CollectionVariantRadios);

class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll("[data-tab]");
    this.contents = this.querySelectorAll("[data-content]");
    this.tabsContainer = this.querySelector(".collection-tabs");

    this.onResize = debounce(() => {
      this.checkTabsOverflow();
      this.updatePillPosition();
    }, 150);
  }

  connectedCallback() {
    if (this.tabs.length === 0) return;
    this.init();
  }

  init() {
    this.bindEvents();
    this.checkTabsOverflow();
    this.showFirstTab();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  bindEvents() {
    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.onTabClick.bind(this));
    });
    window.addEventListener("resize", this.onResize);
  }

  unbindEvents() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener("click", this.onTabClick.bind(this));
    });
    window.removeEventListener("resize", this.onResize);
  }

  checkTabsOverflow() {
    if (!this.tabsContainer) return;

    if (window.innerWidth < 750) {
      const isOverflowing =
        this.tabsContainer.scrollWidth > this.tabsContainer.clientWidth;
      this.tabsContainer.classList.toggle("is-scrollable", isOverflowing);
    } else {
      this.tabsContainer.classList.remove("is-scrollable");
    }
  }

  onTabClick(event) {
    const tab = event.currentTarget;
    const tabNumber = tab.getAttribute("data-tab");
    this.showTab(tabNumber);
  }

  showTab(tabNumber) {
    let activeTab = null;
    this.tabs.forEach((tab) => {
      if (tab.getAttribute("data-tab") === tabNumber) {
        tab.classList.add("active");
        activeTab = tab;
      } else {
        tab.classList.remove("active");
      }
    });

    this.updatePillPosition(activeTab);
    this.updateCurrentTabTitle(tabNumber);

    this.contents.forEach((content) => {
      content.classList.toggle(
        "hidden",
        content.getAttribute("data-content") !== tabNumber
      );
    });
  }

  updatePillPosition(activeTab = this.querySelector(".tab-button.active")) {
    if (!this.tabsContainer || !activeTab) return;

    const target = activeTab;
    this.tabsContainer.style.setProperty(
      "--pill-width",
      `${target.offsetWidth}px`
    );
    this.tabsContainer.style.setProperty(
      "--pill-transform",
      `translateX(${target.offsetLeft}px)`
    );

    // Centrage intelligent des pills sur mobile sans scroll automatique
    if (window.innerWidth < 750) {
      // Vérifier si l'onglet est visible dans le conteneur
      const containerRect = this.tabsContainer.getBoundingClientRect();
      const tabRect = target.getBoundingClientRect();

      // Si l'onglet n'est pas complètement visible, le centrer avec scrollTo
      if (
        tabRect.left < containerRect.left ||
        tabRect.right > containerRect.right
      ) {
        const scrollLeft =
          target.offsetLeft -
          this.tabsContainer.clientWidth / 2 +
          target.offsetWidth / 2;
        this.tabsContainer.scrollTo({
          left: Math.max(0, scrollLeft),
          behavior: "smooth",
        });
      }
    }
  }

  updateCurrentTabTitle(tabNumber) {
    const tabTitles = this.querySelectorAll("[data-tab-title]");
    tabTitles.forEach((title) => {
      title.classList.toggle(
        "hidden",
        title.getAttribute("data-tab-title") !== tabNumber
      );
    });
  }

  showFirstTab() {
    const firstTab = this.tabs[0];
    if (firstTab) {
      this.showTab(firstTab.getAttribute("data-tab"));
    }
  }
}

customElements.define("collection-tabs", CollectionTabs);
